"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addOptionsToSelect = addOptionsToSelect;
const utils_1 = require("@rjsf/utils");
const validator_ajv8_1 = __importDefault(require("@rjsf/validator-ajv8"));
function addOptionsToSelect(scheme, fieldName, options) {
    var _a;
    const field = (_a = scheme.jsonSchema.properties) === null || _a === void 0 ? void 0 : _a[fieldName];
    if (field && typeof field !== 'boolean') {
        const isMulti = (0, utils_1.isMultiSelect)(validator_ajv8_1.default, field);
        if (isMulti) {
            addMultiOptionsToField(field, options);
        }
        else {
            addOptionsToField(field, options);
        }
    }
}
function addOptionsToField(field, options) {
    field.oneOf = options.map(({ value, title }) => ({
        const: value,
        title
    }));
}
function addMultiOptionsToField(field, options) {
    field.items.anyOf = options.map(({ value, title }) => ({
        type: 'string',
        enum: [value],
        title
    }));
}
//# sourceMappingURL=utils.js.map